export const TELESERVER_URL = "https://edtech-demo-gpu.fogteams.com/server1/"


export const WHATSAPP_SERVER_URL = "http://44.202.239.144/"
